import { ORDER } from '.'

const initialOrder = {
  orderId: null,
  orderActionText: null,
  isEditOrder: false,
  previousDrinkHashMap: {},
  previousFoodHashMap: {},
  previousEquipmentHashMap: {},
  currentDrinkHashMap: {},
  currentFoodHashMap: {},
  currentEquipmentHashMap: {},
  confirmItems: [],
}

export default function orderReducer (state = initialOrder, action) {
  switch (action.type) {
    case ORDER.actionType.SET_ALL_ORDER_HASH_MAP:
      return {
        ...state,
        previousDrinkHashMap: action.data.previousDrinkHashMap,
        previousFoodHashMap: action.data.previousFoodHashMap,
        previousEquipmentHashMap: action.data.previousEquipmentHashMap,
        currentDrinkHashMap: action.data.currentDrinkHashMap,
        currentFoodHashMap: action.data.currentFoodHashMap,
        currentEquipmentHashMap: action.data.currentEquipmentHashMap,
      }

    case ORDER.actionType.SET_PREVIOUS_DRINK_HASH_MAP:
      return {
        ...state,
        previousDrinkHashMap: action.data.previousDrinkHashMap,
      }

    case ORDER.actionType.SET_PREVIOUS_FOOD_HASH_MAP:
      return {
        ...state,
        previousFoodHashMap: action.data.previousFoodHashMap,
      }

    case ORDER.actionType.SET_PREVIOUS_EQUIPMENT_HASH_MAP:
      return {
        ...state,
        previousEquipmentHashMap: action.data.previousEquipmentHashMap,
      }

    case ORDER.actionType.SET_CURRENT_DRINK_HASH_MAP:
      return {
        ...state,
        currentDrinkHashMap: action.data.currentDrinkHashMap,
      }

    case ORDER.actionType.SET_CURRENT_FOOD_HASH_MAP:
      return {
        ...state,
        currentFoodHashMap: action.data.currentFoodHashMap,
      }

    case ORDER.actionType.SET_CURRENT_EQUIPMENT_HASH_MAP:
      return {
        ...state,
        currentEquipmentHashMap: action.data.currentEquipmentHashMap,
      }
    
    case ORDER.actionType.SET_ALL_CURRENT_HASH_MAP:
      return {
        ...state,
        currentDrinkHashMap: action.data.currentDrinkHashMap,
        currentFoodHashMap: action.data.currentFoodHashMap,
        currentEquipmentHashMap: action.data.currentEquipmentHashMap,
      }

    case ORDER.actionType.SET_CONFIRM_ITEMS:
      return {
        ...state,
        confirmItems: action.data.confirmItems
      }

    case ORDER.actionType.SET_ORDER_ID:
      return {
        ...state,
        orderId: action.data.orderId
      }

    case ORDER.actionType.SET_ORDER_ACTION_TEXT:
      return {
        ...state,
        orderActionText: action.data.orderActionText
      }

    case ORDER.actionType.SET_IS_EDIT_ORDER:
      return {
        ...state,
        isEditOrder: action.data.isEditOrder
      }

    case ORDER.actionType.RESET_ALL_ORDER:
      return {
        ...state,
        ...initialOrder,
      }
      
    default:
      return state
  }
}
